<div
  class="c-form-element-input"
  [ngClass]="{
    'is-typed': data?.length > 0,
    'is-focus': isFocus || clearBtnFocus,
    'is-error': showError,
    'is-disabled': disabled,
    'c-form-element-input--has-function': displayType === 'tooltip',
    'c-form-element-input--phone': displayType === 'phone'
  }"
>
  <div class="c-form-element-input__box">
    <label class="c-form-element-input__wrap">
      <span class="c-form-element-input__label">
        <span class="c-form-element-input__label-text" [innerHTML]="label"></span>
        <ng-container *ngIf="required">
          <asw-indicator-required></asw-indicator-required>
        </ng-container>
      </span>
      <span class="c-form-element-input__input">
        <span *ngIf="phoneCode" class="c-form-element-input__input-code">{{ phoneCode }}</span>
        <input
          #inputElement
          type="{{ type }}"
          maxlength="{{ maxlength }}"
          id="input_{{ id }}"
          class="c-form-element-input__input-item"
          [(ngModel)]="data"
          [disabled]="disabled"
          placeholder="{{ placeholder }}"
          [attr.autocomplete]="autocomplete"
          [attr.aria-invalid]="isInvalid"
          [attr.aria-required]="required"
          attr.aria-describedBy="{{ isInvalid ? 'input_' + id + '_error' : '' }}"
          (change)="changeHandle($event)"
          (blur)="onBlurHandle($event)"
          (focus)="onFocusHandle()"
        />
      </span>
    </label>
    <div *ngIf="displayType === 'tooltip'" class="c-form-element-input__tooltip">
      <div class="c-form-element-input__tooltip-wrap">
        <button
          id="input-tooltip_{{ id }}"
          class="c-form-element-input__function c-form-element-input__function--hint"
          [aswTooltip]="tooltipContent"
          [tooltipTop]="18"
        >
          <span class="u-visually-hidden" [innerHTML]="'reader.helpIcon.inputText' | staticMsg"></span>
        </button>
      </div>
    </div>
    <button
      type="button"
      *ngIf="showClear"
      id="input-clear_{{ id }}"
      class="c-form-element-input__clear"
      attr.aria-controls="input_{{ id }}"
      [attr.aria-hidden]="!(data?.length > 0 && (isFocus || clearBtnFocus))"
      [tabindex]="!(data?.length > 0 && (isFocus || clearBtnFocus)) ? '-1' : '0'"
      (click)="clearValue()"
      (focus)="onFocusClearBtn()"
      (blur)="onBlurClearBtn()"
    >
      <span class="u-visually-hidden" [innerHTML]="'reader.clearInputInformation' | staticMsg"></span>
    </button>
  </div>
</div>
<asw-validation-error *ngIf="isInvalid" id="input_{{ id }}_error" [errorMessage]="errors[0]"></asw-validation-error>
